export default function newMapView({ state }, { mapViewId, data }) {
  const statePath = ['mapViewById', `${mapViewId}`];

  if (!state.exists(statePath)) {
    state.set(statePath, data);
  }

  state.commit();
}
